import React from 'react';
import type { ReactNode } from 'react';
type MockFrameRatio = '16:10' | '4:3' | '1:1';
interface MockFrameProps {
  ratio: MockFrameRatio;
  caption: string;
  children: ReactNode;
}
const ratioClasses: Record<MockFrameRatio, string> = {
  '16:10': 'aspect-[16/10]',
  '4:3': 'aspect-[4/3]',
  '1:1': 'aspect-square'
};
export const mockTokens = {
  surface: 'bg-white',
  line: 'bg-[#E6E6E2]',
  text: 'bg-[#DCDCD8]',
  heading: 'bg-[#0E0E0E]',
  accent: 'bg-accent',
  typeSmall: 'h-1.5 rounded-full',
  typeLarge: 'h-3 rounded-full'
};
export function MockFrame({
  ratio,
  caption,
  children
}: MockFrameProps) {
  return <figure data-id="element-791" data-mp="uyf2slz5hmve">
      <div className={`group flex ${ratioClasses[ratio]} items-center justify-center overflow-hidden rounded-card border border-hairline bg-surface p-8 transition-[transform,border-color] duration-300 ease-out hover:scale-[1.02] hover:border-ink`} data-id="element-792" data-mp="uy6qav6xwjkq">
        <div className="h-full w-full" data-id="element-793" data-mp="gxm55sdjybo2">{children}</div>
      </div>
      <figcaption className="mt-3 text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-794" data-mp="35iuxts5t55k">
        {caption}
      </figcaption>
    </figure>;
}